import "./heading.css";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { usePreloader } from "../contexts/PreloaderContext";

gsap.registerPlugin(ScrollTrigger);

export function Heading({ title }: { title: string }) {
  const headingRef = useRef<HTMLDivElement>(null);
  const { isComplete } = usePreloader();

  useEffect(() => {
    if (headingRef.current && isComplete) {
      gsap.fromTo(
        headingRef.current,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: headingRef.current,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        },
      );
    }
  }, [isComplete]);

  return (
    <div className="heading" ref={headingRef}>
      <h2 className="heading__title">{title}</h2>
    </div>
  );
}
